
import { defineComponent, ref, computed, onMounted, watch } from 'vue';
import { usePopupStore } from '@/store/popup'
import { useDicomStore } from '@/store/dicom'

export default defineComponent({
  components: {
  },
  props:{
  },
  setup(props, {emit}) {
    const popupStore = usePopupStore();
    const dicomStore = useDicomStore();

    const closePopup = () => {
      popupStore.togglePopup('deleteDicomConfirm', false);
    }

    const handleConfirmClick = async (): Promise<void> => {
      closePopup();
      await dicomStore.deleteDicomList();
    }

    onMounted(() => {
    });

    return {
      closePopup,
      handleConfirmClick
    };
  },
});
